import { appendALExamTemplate } from '@/functions/idp'

import RIC from './RIC_6'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
